import styled from '@emotion/styled/macro';
import vars from '@variables';
import { HighlightAtom } from '@atoms/text-atoms/text-atoms';
import { sectionTitleBorder } from '../../mixins';
import { GatsbyImage } from 'gatsby-plugin-image';

export const HighlightBlockContainer = styled.div<{
  maxHeight?: string;
  narrow?: boolean;
}>`
  max-height: ${({ maxHeight }) =>
    maxHeight ? maxHeight : vars.defaultMaxHeight};
  max-width: ${({ narrow }) => (narrow ? '66.66%' : '100%')};
  margin: ${({ narrow }) => (narrow ? '0 auto' : '0')};

  @media screen and (max-width: ${vars.breakPointTablet}) {
    max-width: 100%;
  }
`;

export const HighlightFrame = styled.div<{ useDottedLine?: boolean }>`
  padding: ${({ useDottedLine }) =>
    useDottedLine ? vars.spacingS : vars.spacingM};

  @media screen and (min-width: ${vars.breakPointTablet}) {
    padding: ${({ useDottedLine }) =>
      useDottedLine ? vars.spacingM : vars.spacingL};
  }
`;

export const AuthorContainer = styled.div`
  display: flex;
  align-items: center;
  margin: ${vars.spacingM} 0;
  gap: ${vars.spacingM};
  @media screen and (min-width: ${vars.breakPointFullWidth}) {
    margin: ${vars.spacingL} 0;
  }
`;

export const AuthorImage = styled(GatsbyImage)`
  width: 66px;
  height: 66px;
  border-radius: 50%;
`;

export const DottedLine = styled.hr`
  border: none;
  border-top: 1px dashed ${vars.borderGrey};
  margin: ${vars.spacingM} 0;
  @media screen and (min-width: ${vars.breakPointFullWidth}) {
    margin: ${vars.spacingL} 0;
  }
`;

export const JobTitleOrganisation = styled.span<{ colour?: string }>`
  ${vars.fontSize3}
  color: ${({ colour }) => colour || vars.coreDarkGrey};
`;

export const ContentContainer = styled.div<{ colour?: string }>`
  ${HighlightAtom} {
    background-color: white;
    color: ${({ colour }) => colour} !important;
    ${({ colour }) => sectionTitleBorder(colour)}
  }
`;
